import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostCreatePaymentSystem = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_PAYMENT
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreatePaymentSystem as SetPostCreatePaymentSystem
}